<template>
  <div id="Header" class="header" :class="{ 'fixed': isFixedHeader }">
    <img class="logo" :src="getLogoImgUrl()" alt="" />
    <div class="flex-content">
      <loginBlock></loginBlock>
      <ul class="menulist">
        <li>
          <record></record>
        </li>
        <li>
          <settingSelectedBlock ref="settingSelectedBlock" @getOpenSettingStatus="getOpenSettingStatus" :is-open-setting.sync="isOpenSetting"></settingSelectedBlock>
          <div class="setting-group" v-if="isOpenSetting">
            <div class="arrow"></div>
            <div class="menulist-block">
              <settingSelectList></settingSelectList>
            </div>
          </div>
        </li>
        <li v-if="!['zh_hk'].includes(language)">
          <langSelectedBlock ref="langSelectedBlock" @getOpenLangStatus="getOpenLangStatus" :is-open-lang.sync="isOpenLang"></langSelectedBlock>
          <div class="lang-group" v-if="isOpenLang">
            <div class="arrow"></div>
            <div class="menulist-block">
              <langSelectList @getLangSelected="getLangSelected"></langSelectList>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import loginBlock from './loginBlock'
import record from './btn/record'
import langSelectedBlock from './btn/lang/langSelectedBlock'
import langSelectList from './btn/lang/langSelectList'
import settingSelectList from './btn/setting/settingSelectList'
import settingSelectedBlock from './btn/setting/settingSelectedBlock'
import Base from '@/mixins/base'
import { mixin as onClickOutside } from 'vue-on-click-outside'
import { mapGetters } from 'vuex'

export default {
  name: 'webHeader',
  mixins: [
    Base,
    onClickOutside
  ],
  props: {
    isFixedHeader: null
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      language: 'app/getLanguage'
    })
  },
  components: {
    loginBlock,
    record,
    langSelectedBlock,
    langSelectList,
    settingSelectList,
    settingSelectedBlock
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  methods: {}
}
</script>

<style scoped></style>
